<template>
    <div class="table-action-buttons">
        <i v-if="this.$can('update-relations')" class="fa fa-edit fa-lg pointer" @click="edit" :title="uLang('app.edit_type', { type: lang('app.relation') })"></i>
        <i v-if="this.$can('delete-relations')" class="fa fa-trash fa-lg pointer" @click="remove" :title="uLang('app.delete_type', { type: lang('app.relation') })"></i>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { DestroyAlert, WarningAlert, SuccessAlert } from "~/Swals";

    export default {
        name: 'actions',
        props: ['data', 'index'],

        computed: mapGetters({
            user: 'authUser'
        }),

        methods: {
            remove() {
                new DestroyAlert({ entity: this.lang('app.relation') }).show().then(async () => {
                    this.destroy()
                });
            },

            edit() {
                this.$router.push({ name: 'admin.relations.edit', params: { id: this.data.id }})
            },

            async destroy() {
                window.axios.delete('/api/admin/relations/' + this.data.id).then(() => {
                    new SuccessAlert({title: this.data.name, text: this.uLang('app.entity_removed', { entity: this.lang('app.relation') })}).show();
                    vue.$emit('reloadTable');
                }).catch(({ response }) => {
                    new WarningAlert({text: response.data.errors.status }).show();
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
